import { constantsTypes } from '../reduxConstants'

export const setLoginViewMode = (value) => {
  return {
    type: constantsTypes.LOGIN_VIEW,
    value: value,
  }
}
